import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
      mt: 10,
    };

    this.button = {
      variant: 'buttons.primary',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      outline: 'none',
      cursor: 'pointer',
      bg: 'black',
      color: 'white',
      width: '100%',
      height: '42px',
      borderRadius: '40px',
      border: 'none',
      logo: {
        backgroundImage: '-webkit-named-image(apple-pay-logo-white)',
        width: '35px',
        height: '100%',
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 50%',
        border: 'none',
      },
      text: {
        color: 'white',
        height: '100%',
      },
    };
  })()
);
